module.exports = "https://web-assets.ifttt.com/packs/media/images/logo-ifttt-white-2f90469f.svg";